import React from 'react';
import { Field } from 'redux-form';
import { TextInput } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CreateItem from '../../../Common/Partials/CreateItem';
import DeleteItem from '../../../Common/Partials/DeleteItem';

const styles = createStyles({
  name: {
    width: '95%'
  },
  value: {
    width: '85%'
  }
});

type Props = {
  classes: any,
  fields: any,
  label: string
};

const Targets = (props: Props) => (
  <div>
    <h5>{props.label}</h5>
    {props.fields.length > 0 && props.fields.map((item, index) => (
      <div key={index}>
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: '1' }}>
            <Field
              className={props.classes.name}
              component={TextInput}
              label="Name"
              name={`${item}.name`}
              placeholder="margin"
              source={`${item}.name`} />
          </div>
          <div style={{ flex: '1' }}>
            <Field
              className={props.classes.value}
              component={TextInput}
              label="Value"
              name={`${item}.value`}
              placeholder="20px"
              source={`${item}.value`} />
            <div style={{ display: 'inline' }}>
              <DeleteItem fields={props.fields} index={index} />
            </div>
          </div>
        </div>
      </div>
    ))}
    <span style={{ color: 'rgba(0, 0, 0, 0.298039)', fontSize: 12 }}>
      Example: key -> value, key2 -> [value2, value3]
    </span>
    <div style={{ paddingTop: 20 }}>
      <CreateItem fields={props.fields} label="Add Target" />
    </div>
  </div>
);

export default withStyles(styles)(Targets);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/Targets.tsx